
import postcssStyledJsxUrlLoader_0 from '../../images/paper-tear-white.png';
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.editorial-wrap__section {
  display: grid;
  grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;

  .editorial-wrap {
    display: grid;
    grid-column: content;
    grid-template-columns: [sidebar] 4fr [content] 8fr;
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    margin: 0 auto;
    max-width: $container-max-width;
    width: 100%;
  }

  &--padding {
    padding-top: 40px;
    .editorial-wrap {
      padding: 0 0 50px;
    }
  }

  .editorial-wrap__sidebar,
  .editorial-wrap__content {
    grid-column: sidebar / span 2;
  }

  .editorial-wrap__sidebar {
    margin-top: -60px;
  }

  .editorial-wrap__sidebar .statistic {
    margin: 0 auto;
  }

  .editorial-wrap__content {
    .rich-text {
      * + * {
        margin-top: 1em;
      }

      h3,
      h4 {
        font-weight: 400;
        font-size: 26px;
      }

      p {
        margin-top: 1em;
        font-size: 16px;
      }

      ul,
      ol {
        margin-top: 1.5em;
        margin-left: 0;

        li {
          margin-top: 1em !important;
          list-style: none !important;
          position: relative;
          background-image: none;
          padding-left: 0;

          &:before {
            content: '';
            background-color: $ui-gray;
            position: absolute;
            height: 0.5rem;
            width: 0.5rem;
            border-radius: 100%;
            margin-left: -16px;
            margin-top: 10px;
          }
        }

        li p {
          margin: 0 !important;
        }
      }
    }

    > .rich-text:first-child > p:first-child {
      margin-top: 0;
      font-size: 1.4em;
      line-height: 1.4;
    }
  }

  .editorial-wrap__image-or-video-with-caption {
    margin: 40px 0;
    text-align: center;

    video,
    img {
      width: auto !important;
      max-width: 100%;
    }
  }

  .editorial-wrap__image-or-video-with-caption--asset {
    max-width: 100%;
    margin: 0 auto;
  }

  .editorial-wrap__image-or-video-with-caption--caption {
    text-align: center;
    font-size: 14px;
    margin: 1em 0 0;
  }

  .editorial-wrap__testimonial {
    margin: 40px 0;

    .testimonial-text-only {
      grid-column-gap: 0 !important;
      grid-template-columns: [content] 1fr !important;
      margin: 4em 0 !important;
      position: relative;

      &::before,
      &::after {
        left: 0;
        width: 100%;
        position: absolute;
        height: 2px;
        background-color: $gray;
        content: ' ';
      }
      &::before {
        bottom: -36px;
      }
      &::after {
        top: -36px;
      }
      .card {
        text-align: left;
        margin: 0 0;

        blockquote {
          padding-bottom: 0;
          font-size: 26px;
          line-height: 37px;
        }
      }
      .result-details {
        margin-top: 8px;
        margin-left: 0;
      }
      .result {
        margin-bottom: 5px;
      }
      .result-avatar {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        overflow: hidden;

        + .result-details {
          .result span {
            font-size: 14px;
            letter-spacing: 0.01em;
            line-height: 18px;
          }
        }
      }
      .result-copy .rich-text p {
        margin-top: 0 !important;
      }
    }
  }
}

main > .editorial-wrap__section ~ .section--richTextEditor {
  margin: 0 !important;

  .rich-text-wrapper {
    max-width: none;
  }

  .rich-text-content {
    max-width: $container-max-width;
    width: 100%;
    margin: 0 auto;
  }

  h2,
  h3 {
    font-weight: 400;
    margin: 0;
  }
}

main > .editorial-wrap__section ~ .section--cardsWithImage {
  margin-top: 40px !important;

  .content {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 50px;
    max-width: $container-max-width;
    width: 100%;
    margin: 0 auto;
  }

  .card-wrapper {
    grid-row-gap: 10px;
  }

  .body {
    margin-bottom: 40px;
  }

  .body span {
    font-size: 20px;
  }

  picture {
    position: relative;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      height: 20px;
      left: -3px;
      right: 0;
      background-image: url("${postcssStyledJsxUrlLoader_0}");
      background-size: 100% 100%;
      background-position: top center;
    }
  }

  .cta-link {
    @include button;

    padding: 12px 21px !important;
    background-color: $slate;
    border: 2px solid $slate;
    color: $white !important;

    &:hover {
      background-color: $white;
      border: 2px solid $slate;
      color: $slate !important;
    }
  }
}

main > .editorial-wrap__section ~ .section--cardsWithImage ~ .section--richTextEditor {
  text-align: center;
  margin-bottom: 100px !important;
}

main > .editorial-wrap__section ~ .section--emailCapture .email-capture {
  grid-column-gap: 0;
}

@include media-query(tablet) {
  .editorial-wrap__section {
    .editorial-wrap__image-or-video-with-caption {
      margin: 32px 0;
    }

    .editorial-wrap__content {
      .rich-text {
        * + * {
          margin-top: 2em;
        }

        h3,
        h4 {
          font-size: 36px;
        }
      }
      > .rich-text:first-child > p:first-child {
        font-size: 1.8em;
      }
    }

    .editorial-wrap__testimonial {
      margin: 60px 0;

      .testimonial-text-only {
        margin: 40px 0 !important;
      }
    }
  }
}

@include media-query(desktop) {
  .editorial-wrap__section {
    &--padding {
      padding-top: 20px;

      .editorial-wrap {
        padding-bottom: 100px;
      }
    }

    .editorial-wrap__sidebar {
      grid-column: sidebar;
      margin-top: -10px;
    }

    .editorial-wrap__sidebar .statistic {
      margin-top: 200px;
    }

    .editorial-wrap__content {
      grid-column: content;
    }
  }
  main > .editorial-wrap__section ~ .section--cardsWithImage {
    .body span {
      font-size: 26px;
    }
  }
}

@media (min-width: 1200px) {
  main > .editorial-wrap__section ~ .section--cardsWithImage {
    .content {
      grid-column-gap: 150px;
    }
  }
}
`